/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SuspentionsInputs */

const en__field_suspentions = /** @type {(inputs: _Field_SuspentionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspensions`)
};

const de__field_suspentions = /** @type {(inputs: _Field_SuspentionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspendierungen`)
};

/**
* | output |
* | --- |
* | "Suspensions" |
*
* @param {_Field_SuspentionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_suspentions = /** @type {((inputs?: _Field_SuspentionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SuspentionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_suspentions(inputs)
	return de__field_suspentions(inputs)
});